const config = {
  nodeEnv: 'prod',
  adobeLaunchScript: '//assets.adobedtm.com/84f7e94eaa36/bb3bc880565f/launch-a03d418d71d7.min.js',
  assetPathAbsolute: 'https://www.northwesternmutual.com/template/assets',
  dynamicConfigBaseUrl: 'https://www.northwesternmutual.com/assets/dynamic-config',
  basePath: 'https://www.northwesternmutual.com',
  mediaBasePath: 'https://media.northwesternmutual.com',
  public: {
    googleAnalyticsTrackingId: 'UA-37147409-29',
    recaptchaInvisible: '6LfDgz8UAAAAADhSYaeXLOogd944BheK0b2VZoRr',
    recaptchaV3: '6LfrTNgUAAAAAH5PukGUxA8sfcS4GhFvd6fPyr8e',
  },
  services: {
    fieldApiBaseUrl: 'https://www.northwesternmutual.com/nmx-api-proxy/nmx/ms-field',
    leadApiBaseUrl: 'https://www.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
    preLeadApiBaseUrl: 'https://www.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
    loginPageUrl: 'https://login.northwesternmutual.com',
    searchApiBaseUrl: 'https://www.northwesternmutual.com/nmx-api-proxy/nmx/ms-search',
    serviceRequestApiBaseUrl: 'https://www.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
  },
};

module.exports = config;
